import React, { memo } from 'react';
import PropTypes from 'prop-types';

const LastMessage = ({ lastMessage }) => {

  return (
    <div
      className="chat-contact-content"
      dangerouslySetInnerHTML={{ __html: `<i>${lastMessage.question}</i>` }}
    />
  );
};

LastMessage.propTypes = {
  lastMessage: PropTypes.object
};

export default memo(LastMessage);
